import ConfirmOrRejectModal from './ConfirmOrRejectModal'

export default ConfirmOrRejectModal
